import { useMemo, useState } from 'react';
import { useSelector } from 'react-redux';
import Select from 'react-select';
import { mainSelectors } from '../../../../store';
import * as storeExt from '../../../../store';
import lodashOrderBy from 'lodash/orderBy';

const { useGetAllProductsQuery } = storeExt;

export const SkuProductContent = (props) => {
    const { tagItem, onSave } = props;

    const { data: products, isLoading: isProductLoading } =
        useGetAllProductsQuery();
    const selectedItemId = useSelector(mainSelectors.getSelectedItemId);
    const [originalValue] = useState({
        value: tagItem.id,
        label: tagItem.name,
    });

    const isSelected = useMemo(() => {
        return selectedItemId === tagItem.id;
    }, [tagItem.id, selectedItemId]);

    const simplifiedProducts = useMemo(() => {
        return !isProductLoading
            ? lodashOrderBy(
                  products.map((prod) => {
                      return {
                          label: prod.name,
                          value: prod.id,
                      };
                  }),
                  ['label'],
                  ['asc'],
              )
            : null;
    }, [products, isProductLoading]);

    const onClickHandler = (event, isSelected) => {
        if (isSelected) {
            event.stopPropagation();
        }
    };

    const onSkuProductChange = (newValue, actionMeta) => {
        switch (actionMeta.action) {
            case 'clear':
                break;
            case 'select-option':
                onSave(newValue.value);
                break;
            default:
                return;
        }
    };

    return (
        <div className="px-4">
            <div
                className="swegon-ui-text-input-wrapper font-bold"
                onClick={(event) => {
                    onClickHandler(event, isSelected);
                }}
            >
                {!isSelected && tagItem.name}
                {isSelected && (
                    <Select
                        styles={{
                            control: (styles) => ({
                                ...styles,
                                backgroundColor: 'white',
                                minHeight: '32px',
                                height: '32px',
                            }),
                            option: (styles, { isFocused, isSelected }) => ({
                                ...styles,
                                backgroundColor: isSelected
                                    ? '#39AA0D'
                                    : isFocused
                                      ? '#39AA0D'
                                      : 'white',
                                color: 'black',
                            }),
                            menu: (styles) => ({
                                ...styles,
                                backgroundColor: 'white',
                            }),
                            singleValue: (styles) => ({
                                ...styles,
                                color: 'black',
                            }),
                        }}
                        placeholder={originalValue.label}
                        defaultValue={originalValue}
                        options={simplifiedProducts}
                        className="basic-single"
                        classNamePrefix="select"
                        name={tagItem.id + '-product'}
                        isSearchable={true}
                        onChange={onSkuProductChange}
                        menuPlacement="bottom"
                    />
                )}
            </div>
            <div className="text-sm text-black-30">{null}</div>
        </div>
    );
};
